<div >
        
    <form class="admin-form">
      <div class="row">
        <div class="input-group" style="height: 25px">
          <input type="text" maxlength="17" class="lookup-input ng-untouched ng-pristine ng-valid"
            ng-reflect-maxlength="17" placeholder="Enter VIN" ng-reflect-model=""
            style="font-size:14px; width: 18%;border: 1px solid #003478;" [(ngModel)]="invinnumber"
            name="invinnumber" id="invinnumber">&nbsp;&nbsp;
          <span>
            <button type="button" class="lookup-btn"
              (click)="getVin()">{{'Fetch Vehicle Model'|translate}}</button>
          </span>
        </div>
      </div>
       <div class="row te-test-row">
       
        <div class="col-sm-6 te-test-para-style">
      {{'Type'|translate}}:<select class="te-test-select" id="type" name="type" [(ngModel)]="type"> 
            <option value>--</option>
            <option value="REPAIR_AND_POST_REPAIR" class="admin-add-btn-col">{{'REPAIR_AND_POST_REPAIR'|translate}}</option>
            <option value="DIAGNOSTIC" class="admin-add-btn-col">{{'DIAGNOSTIC'|translate}}</option>
        </select>&nbsp;
        {{'Language'|translate}}:<input class="te-test-input s" type="text" value="en" name="language" id="language" [(ngModel)]="language"><br>
       {{'Country'|translate}}:<input class="te-test-input" type="text" value="US" name="country" id="country" [(ngModel)]="country">&nbsp;
    {{'Symptom List'|translate}}:<input class="te-test-input" type="text" name="symptomList" id="symptomList" [(ngModel)]="symptomList"><br>
    <span *ngIf="type=='REPAIR_AND_POST_REPAIR'" >{{'Component Id'|translate}}:</span><input list="autocompleteList" autocomplete="on"  (keyup)="updateList()" class="te-test-input p" type="text" *ngIf="type=='REPAIR_AND_POST_REPAIR'" name="componentId" id="componentId" [(ngModel)]="componentId">
    <select *ngIf="type=='REPAIR_AND_POST_REPAIR' && showSuggest" style="width:71%;" size="5" multiple="true" name="componentPost"
    [(ngModel)]="componentPost" #setName (change)="onSelectAllComponent(setName.value)">
    <option *ngFor="let d of TEDescDetails">{{d}}
    </option>
    </select>
    <br>    
    {{'Vehicle Model'|translate}}: <br>
        <textarea  class="te-test-textarea" cols="75" rows="25" name="vehicleModel" id="vehicleModel" [(ngModel)]="vehicleModel"></textarea><br>
        <input *ngIf="type!='REPAIR_AND_POST_REPAIR'" type="submit" name="add" value="{{'Submit'|translate}}" (click)="vindetailsApi()">
        <input *ngIf="type=='REPAIR_AND_POST_REPAIR'" type="submit" name="add" value="{{'Submit'|translate}}" (click)="vindetailsApi1('value')">
    </div>
    <div class="col-sm-6 te-test-para-style">{{'Results'|translate}}:
        <div *ngIf="!isShow" class="te-test-result-text">{{'ID Title Kind Weight Rule Name'|translate}}</div>
        <div *ngIf="!isShow && iserr" class="te-test-result-text1">{{'Candidates are not found'|translate}}</div>
          <table *ngIf="isShow && !iserr">
            <thead>
            <tr>
            <td class="te-test-result-text" style="width:75px">{{'ID'|translate}}</td>
            <td class="te-test-result-text">{{'Title'|translate}}</td>
            <td class="te-test-result-text">{{'Kind'|translate}}</td>
            <td class="te-test-result-text"style="width:75px">{{'Weight'|translate}}</td>
            <td class="te-test-result-text">{{'Rule Name'|translate}}</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor = "let details of submitRes">
            <td>{{details.id}}</td>
            <td>{{details.title}}</td>
            <td>{{details.kind}}</td>
            <td>{{details.weight}}</td>
            <td>{{details.ruleName}}</td>
            </tr>
            
            </tbody>
            </table>
        
    </div>
    </div> 
    </form>
    </div>

